import * as React from 'react';
import {CostStatistics, TotalItemCostStatistics, UsageStatistics} from "../api/dtos/statistics";
import {YearMonth, YearMonthRangePicker} from "./utils/YearMonthRangePicker";
import SectionHeaderFormItem from "../common/form-items/SectionHeaderFormItem";
import {
  createUsageChartData,
  renderAlertStatLayoutItem,
  renderCostStatistics,
  renderPriceStatLayoutItem,
  renderStatHeader,
  renderStatLayout,
  renderStatLayoutItem,
  renderTitledStatLayout,
  renderUnitStatLayoutItem
} from "./utils/statistics-utils";
import locales from "../locales";
import {formatDate} from "../utils/date-utils";
import {ChartData, RentimeChart} from "./RentimeChart";
import {getColor} from "./utils/statistics-colors";

interface Props {
  infiniteStock: boolean;
  onQueryParamsChange: (start: YearMonth, end: YearMonth) => void;
  totalCostStats?: TotalItemCostStatistics;
  usageStats?: UsageStatistics;
  costStats?: CostStatistics;
}

interface State {
  start?: YearMonth;
  end?: YearMonth;
}

export default class ItemStatisticsPanel extends React.Component<Props, State> {

  public render(): React.ReactNode {
    const {totalCostStats, usageStats, costStats, infiniteStock} = this.props;
    return (
      <>
        {totalCostStats && this.renderTotalCostStats((totalCostStats))}
        <SectionHeaderFormItem title={locales.range}/>
        <YearMonthRangePicker
          onRangeClear={this.onRangeClear}
          onRangePick={this.onRangePick}
        />
        {costStats && renderCostStatistics(costStats)}
        {usageStats && this.renderUsageStatistics(usageStats, !infiniteStock)}
      </>
    );
  }

  private onRangeClear = () => {
    this.setState({
      start: undefined,
      end: undefined,
    });
  };

  private onRangePick = (start: YearMonth | undefined, end: YearMonth | undefined) => {
    this.setState({start, end});
    if (start && end) {
      this.props.onQueryParamsChange(start, end)
    }
  };

  private renderTotalCostStats = (stats: TotalItemCostStatistics): React.ReactNode => {
    return renderTitledStatLayout(
      locales.total_income,
      <>
        {renderStatLayoutItem(locales.item_registration, formatDate(stats.since))}
        {stats.until && renderStatLayoutItem(locales.item_deletion, formatDate(stats.until))}
        {renderPriceStatLayoutItem(locales.initial_cost, stats.initialCost)}
        {renderPriceStatLayoutItem(locales.total_maintenance_cost, stats.totalMaintenanceCost)}
        {renderPriceStatLayoutItem(locales.internal_usage_cost, stats.internalUsageCost)}
        {renderPriceStatLayoutItem(locales.total_rental_income, stats.totalRentalIncome)}
        {renderPriceStatLayoutItem(locales.total_maintenance_income, stats.totalMaintenanceIncome)}
        {renderPriceStatLayoutItem(locales.profit, stats.profit)}
      </>
    );
  };

  private renderUsageStatistics = (usageStats: UsageStatistics, show: boolean): React.ReactNode => {
    const chartData: ChartData = usageStats ? createUsageChartData(usageStats) : undefined;
    const total = usageStats.days;
    return (
      <>
        {renderStatHeader(locales.usage)}
        {renderStatLayout(
          <>
            {show && renderUnitStatLayoutItem(locales.state_rented, usageStats.daysRented, locales.day, getColor(0), total)}
            {show && renderUnitStatLayoutItem(locales.not_used, usageStats.daysUnused, locales.day, getColor(1), total)}
            <b>{show && renderUnitStatLayoutItem(locales.total, total, locales.day)}</b>
            {renderAlertStatLayoutItem(locales.usage_statistics_notes)}
          </>,
          <>
            {show && <RentimeChart unit={locales.day} data={chartData}/>}
          </>
        )}
      </>
    );
  };
}



// WEBPACK FOOTER //
// ./src/statistics/ItemStatisticsPanel.tsx